export default __webpack_public_path__ + "static/media/blog-five2.61937475.jpg";